import { environment } from '@env'
import { ApplicationMenuConfig, ApplicationName } from '@performance/ui'

export const APPLICATION_CONFIG: ApplicationMenuConfig = {
  environment: environment.envType,
  application: ApplicationName.BackOffice,
  blacklist: environment.PROFILE_TYPE_BLACKLIST,
}
